import api from './api';

const BASE_URL = '/lessons-learned';

const lessonLearnedService = {
  // Get all lessons learned with optional filters
  getLessonsLearned: async (params = {}) => {
    const response = await api.get(BASE_URL, { params });
    return response.data;
  },

  // Get a single lesson learned by ID
  getLessonLearned: async (id) => {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Create a new lesson learned
  createLessonLearned: async (data) => {
    const response = await api.post(BASE_URL, data);
    return response.data;
  },

  // Update an existing lesson learned
  updateLessonLearned: async (id, data) => {
    const response = await api.put(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  // Delete a lesson learned
  deleteLessonLearned: async (id) => {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Mark lesson as helpful
  markAsHelpful: async (id) => {
    const response = await api.post(`${BASE_URL}/${id}/helpful`);
    return response.data;
  },

  // Get lessons learned statistics
  getLessonsLearnedStats: async (params = {}) => {
    const response = await api.get(`${BASE_URL}/stats`, { params });
    return response.data;
  }
};

export default lessonLearnedService;

